<script>
import { Bar, mixins } from "vue-chartjs";

const barBackgroundColor = "rgba(54, 162, 235, 0.2)";
const barBorderColor = "rgba(128, 128, 128, 1)";

export default {
  name: "JJRiskChart",
  mixins: [Bar, mixins.reactiveData],
  data: function() {
    return {
      chartData: {
        labels: [
          "冠動脈心疾患",
          "脳卒中",
          "非心血管死亡",
          "顕性腎症",
          "網膜症進展"
        ],
        datasets: [
          {
            label: "",
            data: [0, 0, 0, 0, 0],
            backgroundColor: [
              barBackgroundColor,
              barBackgroundColor,
              barBackgroundColor,
              barBackgroundColor,
              barBackgroundColor
            ],
            borderColor: [
              barBorderColor,
              barBorderColor,
              barBorderColor,
              barBorderColor,
              barBorderColor
            ],
            borderWidth: 1
          }
        ]
      },
      options: {
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: false,
          fontSize: 24,
          text: "糖尿病合併症リスク"
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 1
              }
            }
          ]
        }
      }
    };
  },
  methods: {
    setYAxesMax: function(value) {
      this.options.scales.yAxes[0].ticks.max = value;
      this.renderChart(this.chartData, this.options);
    },
    updateChartData: function(data) {
      const newChartData = Object.assign({}, this.chartData);
      newChartData.datasets[0].data[0] = data.CHD;
      newChartData.datasets[0].data[1] = data.Stroke;
      newChartData.datasets[0].data[2] = data.NonCVMortality;
      newChartData.datasets[0].data[3] = data.Nephropathy;
      newChartData.datasets[0].data[4] = data.Retinopathy;
      this.chartData = newChartData;
    }
  },
  mounted: function() {
    this.renderChart(this.chartData, this.options);
  }
};
</script>
